import { BaseService } from 'shared/services/BaseService';
import { IOperationalUnit } from '../types';

class OperationalUnitService extends BaseService<IOperationalUnit> {
  constructor() {
    super('operational-units');
  }
}

export const operationalUnitService = new OperationalUnitService();
